<template>
  <div class="home-skeleton">
    <div class="item" :style="{ backgroundColor: bg }">
      <shSkeleton bg="#e4e4e4" width="510px" height="380px" animated />
    </div>
    <div class="item-desc">
      <div class="item-title">
        <shSkeleton bg="#e4e4e4" width="708px" height="60px" animated />
      </div>

      <div style="margin-top: 5px">
        <shSkeleton bg="#e4e4e4" width="685px" height="60px" animated />
      </div>

      <div style="margin-top: 5px">
        <shSkeleton bg="#e4e4e4" width="685px" height="60px" animated />
      </div>

      <div style="margin-top: 5px">
        <shSkeleton bg="#e4e4e4" width="685px" height="60px" animated />
      </div>
      <div style="margin-top: 5px">
        <shSkeleton bg="#e4e4e4" width="685px" height="60px" animated />
      </div>

      <div style="margin-top: 5px; float: right">
        <shSkeleton bg="#e4e4e4" width="235px" height="45px" animated />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeSkeleton",
  props: {
    bg: {
      type: String,
      default: "#fff",
    },
  },
};
</script>

<style scoped lang="less">
.home-skeleton {
  width: 1240px;
  height: 410px;
  display: flex;
  //flex-wrap: wrap;
  margin-left: 7px;
  margin-top: 10px;
  //justify-content: space-between;

  .item {
    width: 505px;
    height: 345px;
    margin-left: 8px;
    margin-top: 5px;
    border-radius: 5px;
    .sh-skeleton {
      width: 65px;
      height: 30px;
    }
    //margin-bottom: 8px;
    /* .sh-skeleton ~ .sh-skeleton {
      display: block;
      margin: 8px auto 0;
    } */
  }
  .item-desc {
    width: 690px;
    margin-left: 10px;
    //margin: 0px 10px 5px 15px;
    .item-list {
      width: 690px;
      height: 95px;
      display: flex;

      /* .item {
        width: 70px;
        height: 30px;
        align-self: center;
      } */
      /* .list {
        width: 690px;
        //height: 95px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        .right {
          padding: 5px 10px 5px 10px;
        }
      } */
    }
  }
}
</style>
